var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSearchIconGrey = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab{fill:#95A1B2;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M17.559,15.432l-3.91-3.91c-.021-.021-.045-.035-.067-.055a7.4,7.4,0,1,0-2.115,2.115c.019.022.034.046.055.067l3.91,3.91a1.5,1.5,0,1,0,2.127-2.127ZM7.4,12.235A4.835,4.835,0,1,1,12.235,7.4,4.835,4.835,0,0,1,7.4,12.235Z",
    transform: "translate(0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchIconGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-icon-grey.82f88897.svg";
export { ForwardRef as ReactComponent };